import { Component, ViewChild } from '@angular/core';
import { Optional, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ImageCropperComponent, ImageTransform } from 'ngx-image-cropper';

export interface ImageModel {
  images: Array<string>;
  imageOptions: ImageOptions;
}

export interface ImageOptions {
  aspectRation: number;
  resizeHeight: number;
  resizeWidth: number;
}

@Component({
  selector: 'monorepo-image-cropper-container',
  templateUrl: './image-cropper-container.component.html',
  styleUrls: ['./image-cropper-container.component.scss'],
})
export class ImageCropperContainerComponent {
  @ViewChild(ImageCropperComponent)
  imageCropper: ImageCropperComponent;

  imageData: any;
  imageList = [];
  imageURL: string;
  croppedImage: any;
  finalImage: any;
  currentIndex = 0;
  results = [];
  images = [];
  allFiles = [];
  imagepath: any;
  isLoaded = true;
  transform: ImageTransform = {};
  options: any = {
    floor: 100,
    ceil: 300,
  };
  image: string = null;
  imageOption: ImageOptions;

  constructor(
    public dialogRef: MatDialogRef<ImageCropperContainerComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: ImageModel
  ) {
    this.imageList = data.images;
    this.imageOption = data.imageOptions;
  }

  public selectedImage(_image: string, index: number): void {
    this.isLoaded = true;
    this.currentIndex = index;
    this.imageURL = this.imageList[this.currentIndex];
  }

  public imageLoaded(): void {
    this.isLoaded = false;
  }

  public cropImage(): void {
    this.results[this.currentIndex] = this.imageCropper.crop().base64;
  }

  public close(): void {
    this.resetImage();
    this.dialogRef.close(this.results);
  }

  public scaleImage(event): void {
    this.transform = {
      ...this.transform,
      scale: event / 100,
    };
  }

  public save(): void {
    this.cropImage();
    if (this.results.length !== this.imageList.length) {
      return;
    }
    this.dialogRef.close(this.results);
    this.resetImage();
  }

  private resetImage(): void {
    this.imageCropper.imageURL = null;
    this.imageURL = '';
    this.imageList = [];
    this.results = [];
  }
}
